import { render, staticRenderFns } from "./selectionStatistics.vue?vue&type=template&id=56806c5d&scoped=true"
import script from "./selectionStatistics.vue?vue&type=script&lang=js"
export * from "./selectionStatistics.vue?vue&type=script&lang=js"
import style0 from "./selectionStatistics.vue?vue&type=style&index=0&id=56806c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56806c5d",
  null
  
)

export default component.exports